"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNSUBSCRIBE_LEVEL2 = exports.SUBSCRIBE_LEVEL2 = exports.REQUEST_LEVEL_2_DATA = exports.RECEIVE_LEVEL_2_DATA = exports.LEVEL_2_UPDATES = void 0;
exports.getAllLevel2 = getAllLevel2;
exports.level2Updates = level2Updates;
exports.unsubscribeLevel2 = exports.subscribeToLevel2 = exports.requestLevel2Data = void 0;
var SUBSCRIBE_LEVEL2 = exports.SUBSCRIBE_LEVEL2 = 'SUBSCRIBE_LEVEL_2';
var UNSUBSCRIBE_LEVEL2 = exports.UNSUBSCRIBE_LEVEL2 = 'UNSUBSCRIBE_LEVEL_2';
var RECEIVE_LEVEL_2_DATA = exports.RECEIVE_LEVEL_2_DATA = 'RECEIVE_LEVEL_2_DATA';
var LEVEL_2_UPDATES = exports.LEVEL_2_UPDATES = 'LEVEL_2_UPDATES';
var REQUEST_LEVEL_2_DATA = exports.REQUEST_LEVEL_2_DATA = 'REQUEST_LEVEL_2_DATA';

/**
 * Add listener for level2 updates
 */
var subscribeToLevel2 = exports.subscribeToLevel2 = function subscribeToLevel2(instrumentId) {
  return {
    type: SUBSCRIBE_LEVEL2,
    payload: {
      instrumentId: instrumentId
    }
  };
};

/**
 * Stop getting updates from server for passed `insrtumentId`
 */
var unsubscribeLevel2 = exports.unsubscribeLevel2 = function unsubscribeLevel2(instrumentId) {
  return {
    type: UNSUBSCRIBE_LEVEL2,
    payload: {
      instrumentId: instrumentId
    }
  };
};
function getAllLevel2(updates) {
  return {
    type: RECEIVE_LEVEL_2_DATA,
    payload: updates
  };
}
var requestLevel2Data = exports.requestLevel2Data = function requestLevel2Data(instrumentId) {
  return {
    type: REQUEST_LEVEL_2_DATA,
    payload: instrumentId
  };
};
function level2Updates(updates) {
  return {
    type: LEVEL_2_UPDATES,
    payload: updates
  };
}